<nav aria-label="breadcrumb">
    <ol class="breadcrumb">
        <li class="breadcrumb-item">
            <a routerLink="/dashboard" style="color: #003E53;">Dashboard</a>
        </li>
        @if(distributorType == 1){

        <li class="breadcrumb-item">
            <a routerLink="/wholesalers" style="color: #003E53;">Distributor</a>
        </li>
        }@else {
        <li class="breadcrumb-item">
            <a routerLink="/retailers" style="color: #003E53;">Distributor</a>
        </li>
        }


        <li class="breadcrumb-item active" aria-current="page">
            Assign Samples {{distributorData?.name}}
        </li>
    </ol>
</nav>

<div class="row">
    <div class="col-xl-12">
        <app-card cardTitle="Basic Table" [options]="false" blockClass="table-border-style">
            <div class="row align-items-center mb-3 gx-2">
                <div class="col-md-8 col-12 mb-2 mb-md-0 ">
                    <h5 class="mb-0 text-dark fw-bold">
                        Assign Sample To
                        <span style="text-transform: capitalize; color:#003E53">
                            {{ distributorType == 1 ? 'Wholesaler' : 'Retailer' }}: {{ distributorData?.name }}
                        </span>
                    </h5>
                    <div class="d-flex flex-wrap justify-content-md-start mt-1 gap-2">
                        @if (distributorData?.email) {
                        <a class="text-muted small text-decoration-none d-flex align-items-center">
                            <i class="bi bi-envelope me-1 fs-7"></i>
                            <span class="text-truncate" style="max-width: 140px;">
                                {{ distributorData.email }}
                            </span>
                        </a>
                        }
                        @if (distributorData?.phone) {
                        <a class="text-muted small text-decoration-none d-flex align-items-center">
                            <i class="bi bi-telephone me-2 fs-7"></i>
                            {{ distributorData.phone }}
                        </a>
                        }
                    </div>
                </div>
            </div>
            <hr class="m-0 p-0">
            <hr class="m-0 p-0">
            <div class="row">
                <div class="col-12 col-md-5">
                    <mat-card class="mt-2 h-100">
                        <mat-card-content class="d-flex flex-column" style="height: 80vh;">
                            <!-- Select All Button -->
                            <div class="d-flex justify-content-between align-items-center mb-2">
                                <!-- Heading -->
                                <h5 class="mb-0 fw-bold">Samples List</h5>

                                <!-- Button -->
                                <button type="button"
                                    class="btn btn-sm btn-outline-primary rounded-2 d-flex align-items-center gap-1"
                                    (click)="selectAllSamples()">
                                    Select All
                                </button>
                            </div>
                            <!-- Search Field -->
                            <div class="row g-2 flex-wrap d-flex align-items-end mb-2">
                                <div class="col-12">
                                    <mat-form-field class="dense w-100">
                                        <mat-label>Sample Name</mat-label>
                                        <input matInput [(ngModel)]="sampleSearch.name" name="name"
                                            (input)="onNameInputChange($event)">
                                    </mat-form-field>
                                </div>
                            </div>

                            <!-- Table -->
                            <div class="table-responsive" style="max-height: 400px; overflow-y: auto;">
                                <div class="mat-elevation-z8">
                                    <table mat-table [dataSource]="dataSource" class="table-bordered compact-table"
                                        style="min-width: 100%;">
                                        <!-- Column: Name -->
                                        <ng-container matColumnDef="name">
                                            <th mat-header-cell *matHeaderCellDef>Sample Name</th>
                                            <td mat-cell *matCellDef="let element">
                                                <div class="fw-medium">{{ element.name }}</div>
                                                <small class="text-muted fs-7">{{ element.categoryId.name }}</small>
                                            </td>
                                        </ng-container>

                                        <!-- Column: Stock -->
                                        <ng-container matColumnDef="stock">
                                            <th mat-header-cell *matHeaderCellDef>Stock</th>
                                            <td mat-cell *matCellDef="let element">{{ element.leftItems }}</td>
                                        </ng-container>

                                        <!-- Column: Action -->
                                        <ng-container matColumnDef="action">
                                            <th mat-header-cell *matHeaderCellDef>Action</th>
                                            <td mat-cell *matCellDef="let element">
                                                <div class="d-flex align-items-center justify-content-center mx-2">
                                                    <button type="button"
                                                        class="btn btn-sm btn-primary rounded-2 d-flex align-items-center justify-content-center p-0"
                                                        style="width: 20px; height: 20px;"
                                                        (click)="assignSample(element)">
                                                        <mat-icon fontIcon="add"
                                                            class="d-flex align-items-center justify-content-center"></mat-icon>
                                                    </button>
                                                </div>
                                            </td>
                                        </ng-container>
                                        <!-- Header and Row -->
                                        <tr mat-header-row *matHeaderRowDef="displayedColumns" class="t_head "></tr>
                                        <tr mat-row *matRowDef="let row; columns: displayedColumns;"></tr>

                                        <!-- No Data -->
                                        <tr class="mat-row" *matNoDataRow>
                                            <td class="mat-cell text-center" [attr.colspan]="displayedColumns.length">
                                                No data available
                                            </td>
                                        </tr>
                                    </table>
                                </div>
                            </div>
                        </mat-card-content>
                    </mat-card>
                </div>

                <div class="col-12 col-md-7">
                    <form [formGroup]="assignSampleForm" (ngSubmit)="submit()">
                        <mat-card class="mt-2 custom-scrollbar " style="height: 80vh; overflow: hidden;">
                            <mat-card-content class="flex-grow-1 overflow-auto pe-2 custom-scrollbar">
                                @if (sampleList.length === 0) {
                                <div class="text-muted">No samples selected yet.</div>
                                } @else {
                                <div formArrayName="sampleList" style="max-height: 475px; overflow-y: auto;">
                                    @for (sample of assignedSamples; track sample) {
                                    <div [formGroupName]="$index" class="border rounded p-2 mb-2"
                                        [ngClass]="{ 'border-danger': sample.error, 'border': true }">
                                        <div class="d-flex justify-content-between align-items-center">
                                            <!-- Info section -->
                                            <div class="flex-grow-1">
                                                <span class="fw-semibold text-dark me-3">{{ sample.name }}</span>

                                                <small class="text-muted me-3">
                                                    <i class="bi bi-box-arrow-in-down text-primary me-1"></i>
                                                    <span class="fw-medium">Previously Assigned:</span> {{
                                                    sample.previousAssigned }}
                                                </small>

                                                <small class="text-muted">
                                                    <i class="bi bi-archive text-success me-1"></i>
                                                    <span class="fw-medium">Remaining:</span> {{ sample.remainingQty }}
                                                </small>
                                            </div>

                                            <button type="button"
                                                class="btn btn-sm btn-primary rounded-2 d-flex align-items-center justify-content-center p-0"
                                                style="width: 20px; height: 20px;" (click)="removeSample($index)">
                                                <mat-icon fontIcon="close"
                                                    class="d-flex align-items-center justify-content-center"></mat-icon>
                                            </button>
                                        </div>

                                        <div class="row mt-2 gx-2">
                                            <div class="col-6">
                                                <input type="number" class="form-control form-control-sm py-1"
                                                    placeholder="Enter Quantity" formControlName="quantityAssigned"
                                                    min="1">
                                                @if (
                                                sampleList.at($index)?.get('quantityAssigned')?.invalid &&
                                                sampleList.at($index)?.get('quantityAssigned')?.dirty
                                                ) {

                                                <div class="text-danger small">
                                                    Enter valid quantity.
                                                </div>
                                                }
                                                @else {
                                                <small class="text-muted">Qty</small>
                                                }
                                            </div>
                                            <div class="col-6">
                                                <input type="number" class="form-control form-control-sm py-1" min="0"
                                                    placeholder="Enter Limit" formControlName="distributorLimit" (keyup)="changeLimit($index,sample)">
                                                @if (
                                                sampleList.at($index)?.get('distributorLimit')?.invalid &&
                                                sampleList.at($index)?.get('distributorLimit')?.dirty
                                                ) {
                                                <div class="text-danger small">
                                                    You cannot assign less than the default limit.
                                                </div>
                                                }
                                                @else {
                                                <small class="text-muted">Limit</small>
                                                }
                                            </div>
                                        </div>
                                        @if (sample.error) {
                                        <div class="text-danger small mt-2 d-flex align-items-center gap-1">
                                            <i class="bi bi-exclamation-circle"></i>
                                            {{ sample.error }}
                                        </div>
                                        }
                                    </div>
                                    }
                                </div>
                                }
                            </mat-card-content>
                            @if (sampleList.length > 0) {
                            <mat-card-actions class="d-flex justify-content-between align-items-center">
                                <div class="text-muted d-flex align-items-center">
                                    <i class="bi bi-list-check me-1"></i>
                                    {{ sampleList.length }} selected
                                </div>
                                <button type="submit" class="btn btn-sm btn-primary rounded-2"
                                    [disabled]="assignSampleForm.invalid">
                                    Save
                                </button>
                            </mat-card-actions>
                            }
                        </mat-card>
                    </form>
                </div>
            </div>
        </app-card>

    </div>
</div>
